<template>
  <div>
    <x-background-image />
    <layout-center>
      <v-card width="750px" class="py-10 login-card pb-6 card-padding" :elevation="0">
        <v-card-text class="pa-8">
          <img :src="$logos.bigger" alt="XTUR Sp. z o.o." />
          <h4 class="text-h4 mt-6 mb-6">{{ $t("logIntoMidOfficeSystem") }}<br />xTur 3.0</h4>
          <v-form ref="form" @submit.prevent="clickLogin">
            <v-select
              ref="company-input"
              v-model="model.officeId"
              :items="$store.state.offices.allOffices"
              item-value="id"
              item-text="officeShortName"
              class="large px-8"
              :label="$t('office') | capitalize"
              :rules="[requiredValidator]"
              rounded
            />
            <v-divider class="mb-8 mt-2" />
            <v-text-field
              ref="login-input"
              v-model="model.login"
              class="large px-8"
              hide-details="auto"
              rounded
              :label="$t('login') | capitalize"
              :rules="[requiredValidator]"
              @keypress:enter="clickLogin"
            />
            <v-text-field
              ref="password-input"
              v-model="model.password"
              class="large px-8"
              hide-details="auto"
              :label="$t('password') | capitalize"
              :rules="[requiredValidator]"
              type="password"
              rounded
              @keypress:enter="clickLogin"
            />

            <div class="mt-6 text-caption">
              {{ $t("forgottenPassword?") | capitalize }}
              <router-link :to="{ name: 'Remind Password' }">
                {{ $t("clickHere") | capitalize }}
              </router-link>
            </div>

            <v-btn class="primary" type="submit" rounded x-large min-width="235px">
              {{ $t("loginButton") | capitalize }}
            </v-btn>

            <div style="width: 100%; text-align: center">
              <img
                alt="XTUR Sp. z o.o."
                src="@/assets/images/logoUnia.png"
                style="width: 595px; margin-left: -75px; margin-top: 50px"
              />
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </layout-center>
  </div>
</template>

<script lang="ts">
import PostUserLoginRequest from "@/models/api/user/PostUserLoginRequest";
import { Component, Vue, Watch } from "vue-property-decorator";
import requiredValidator from "@/rules/requiredValidator";
import { VForm } from "@/models/components/inputs/vForm";
import GetOfficeItem from "@/models/api/offices/GetOfficeResponse";
import { filterCapitalize } from "@/filters/capitalize";
import i18n from "@/plugins/i18n";
import XBackgroundImage from "@/components/shared/layout/XBackgroundImage.vue";
import LayoutCenter from "@/components/shared/layout/LayoutCenter.vue";
@Component({
  components: { LayoutCenter, XBackgroundImage },
})
export default class LoginView extends Vue {
  get windowTitle(): string {
    return filterCapitalize(i18n.t("loginToSystem"));
  }

  requiredValidator = requiredValidator;
  model: PostUserLoginRequest = {
    login: "",
    password: "",
    officeId: "",
  };
  clickLogin = async (): Promise<void> => {
    const form = this.$refs.form as VForm;
    if (form.validate()) {
      await this.$store.direct.dispatch.user.login(this.model);
    }
  };

  get offices(): Array<GetOfficeItem> {
    return this.$store.direct.state.offices.allOffices;
  }

  @Watch("offices")
  setDefaultOffice(): void {
    const officeFromUrl = this.$store.direct.state.offices.allOffices.find(
      (v) => v.officeShortName === this.$route.params.officeShortName
    );
    if (typeof officeFromUrl !== "undefined") {
      this.model.officeId = officeFromUrl.id;
    }
  }

  mounted(): void {
    this.setDefaultOffice();
  }
}
</script>

<style scoped>
.login-card {
  margin: auto;
}

.login-card > div {
  text-align: center;
}
</style>
